    
import React from "react";
import { withGoogleMap, GoogleMap, Marker } from "react-google-maps";

const GettingStartedGoogleMap = withGoogleMap(props => (
  <GoogleMap
    ref={ props.onMapLoad }
    defaultZoom={ props.markers[0].zoom }
    defaultCenter={{ lat: props.markers[0].position.lat, lng: props.markers[0].position.lng }}
  >
    {props.markers.map(marker => (
      <Marker
        {...marker}
      />
    ))}
  </GoogleMap>
));

export default class GoogleMaps extends React.Component {
  state = {
    markers: [{
      position: {
        lat: this.props.mapData.lat,
        lng: this.props.mapData.lng,
      },
      key: this.props.mapData.key,
      defaultAnimation: this.props.mapData.markerAnimation,
      zoom: this.props.mapData.zoom
    }],
  };

  handleMapLoad = this.handleMapLoad.bind(this);

  handleMapLoad(map) {
    this._mapComponent = map;
  }

  render() {
    const props = this.props;
    return (
      <div style= { props.elementStyle }>
        <GettingStartedGoogleMap
          containerElement={
            <div style={ props.containerStyle } />
          }
          mapElement={
            <div style={ props.elementStyle } />
          }
          onMapLoad={ this.handleMapLoad }
          markers={ this.state.markers }
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ga-maps/map.jsx